import { PortalPublicConfigurationModel } from '@portal-clients/configuration';

import { KeyValueStore } from '@frontend/utils';

interface PortalPublicConfigurationCacheModel
  extends PortalPublicConfigurationModel {
  appVersionHash: string | undefined;
}

export const portalConfigurationCache = {
  async get(): Promise<PortalPublicConfigurationCacheModel | undefined> {
    const cached = await KeyValueStore.get('portal-configuration');

    if (!cached) {
      return undefined;
    }

    return JSON.parse(cached);
  },

  async set(configuration: PortalPublicConfigurationCacheModel): Promise<void> {
    await KeyValueStore.set(
      'portal-configuration',
      JSON.stringify(configuration),
    );
  },
};
